// extracted by mini-css-extract-plugin
export var dayLabel = "_iz-0";
export var pickerDisabled = "_iz-1";